export default function sidebarNav() {

    $(function(){
        const $html = $('html');

        $('.header-menu-toggle').on('click', function(e){
            e.preventDefault();
            $html.toggleClass('sidebar-open');
        });

        $('.sidebar-overlay, .sidebar-close').on('click', function(e){
            e.preventDefault();
            $html.removeClass('sidebar-open');
        });

        $('.booking-link').on('click', function(){
            $html.removeClass('sidebar-open');
        });
    });

}
